module.exports = __webpack_public_path__ + "img/blogpost8.ad2d6e5f.jpg";